import { useEffect } from 'react';
import { exitFullscreen } from '../utils/fullscreen';

// The deps array must stay empty — do not merge this into the effect inside
// useSuspiciousActivityTracking, whose deps include `logSuspiciousActivity`. That value is
// recreated whenever the session id or skillId changes, so sharing that effect would yank the
// student out of full screen mid-assessment.
//
// fullscreenchange fires asynchronously (a queued task, not synchronously from
// exitFullscreen()), so by the time it lands, the tracking hook's listener has already been
// removed by unmount — our own exit is never observed by it.
export const useExitFullscreenOnUnmount = () => {
  useEffect(() => () => exitFullscreen(), []);
};
